import keyMirror from '../../util/keyMirror';

export default keyMirror('App', [
    'LOAD_APP_DATA_START',
    'LOAD_APP_DATA_SUCCESS',
    'LOAD_APP_DATA_FAIL',
]);
